import { useState } from "react";

import {
  InternalContainer,
  ExternalContainer,
  TitleSubtitle,
} from "../Reusable/Layout";
import { EditGamerIcon, DeleteIcon } from "../../assets/Icons";
import { data } from "../../assets/DemoData";

export const GamerTags = () => {
  const [editTag, setEditTag] = useState(false);
  return (
    <ExternalContainer>
      <InternalContainer headerText="Gamer Tag">
        <div className="col-4">
          {data.map((tag, index) => (
            <div className="p-2 rounded-lg row-3">
              <img
                src={tag.image}
                alt=""
                className="size-[50px] object-cover rounded-lg"
              />
              <div className="row-4 justify-between items-center w-full">
                <TitleSubtitle title={tag.title} subtitle={tag.game} />
                <div className="row-4">
                  <button
                    onClick={() => {
                      setEditTag(true);
                    }}
                  >
                    <EditGamerIcon />
                  </button>
                  <DeleteIcon />
                </div>
              </div>
            </div>
          ))}
          {/* <Modal
              isOpen={editTag}
              onClose={() => {
                setEditTag(false);
              }}
            >
              <AccountContainer headerText="Change Gamer Tag">
                <Input type="text" placeholder="Gamer Tag" value="" />
                <div className="flex justify-end">
                  <Button text="Save change" />
                </div>
              </AccountContainer>
            </Modal> */}
        </div>
      </InternalContainer>
    </ExternalContainer>
  );
};
